type IntercomModule = typeof import('@intercom/messenger-js-sdk')
type IntercomMethod =
  | 'Intercom'
  | 'boot'
  | 'shutdown'
  | 'show'
  | 'showConversation'
  | 'showNewMessage'
  | 'trackEvent'

let intercomModule: IntercomModule | null = null
let intercomModulePromise: Promise<IntercomModule | null> | null = null

const loadIntercom = () => {
  if (!useIsBrowser()) {
    return Promise.resolve(null)
  }

  if (!intercomModulePromise) {
    intercomModulePromise = import('@intercom/messenger-js-sdk')
      .then((module) => {
        intercomModule = module
        module.Intercom({ app_id: 'qhptt90l' })
        return module
      })
      .catch((error) => {
        intercomModulePromise = null
        console.error('Failed to load Intercom SDK:', error)
        return null
      })
  }

  return intercomModulePromise
}

const callIntercom = (method: IntercomMethod, ...args: any[]) => {
  if (!useIsBrowser()) {
    return
  }

  const fn = intercomModule?.[method]
  if (typeof fn === 'function') {
    return fn(...args)
  }

  void loadIntercom().then((module) => {
    const loadedFn = module?.[method]
    if (typeof loadedFn === 'function') {
      loadedFn(...args)
    }
  })
}

if (useIsBrowser()) {
  void loadIntercom()
}

export const useIntercom = () => {
  return {
    Intercom: (...args: any[]) => callIntercom('Intercom', ...args),
    boot: (...args: any[]) => callIntercom('boot', ...args),
    shutdown: (...args: any[]) => callIntercom('shutdown', ...args),
    show: (...args: any[]) => callIntercom('show', ...args),
    showConversation: (...args: any[]) => callIntercom('showConversation', ...args),
    showNewMessage: (...args: any[]) => callIntercom('showNewMessage', ...args),
    trackEvent: (...args: any[]) => callIntercom('trackEvent', ...args),
  }
}
